import { IntervalSchema, RuleEditorSchema } from "@superwall-me/schema";
export const parseTriggerExperiment = (triggerExperiment)=>{
    const interval = triggerExperiment.interval ? IntervalSchema.parse(triggerExperiment.interval) : null;
    const transformedRuleConditions = triggerExperiment.ruleConditions ? {
        ...JSON.parse(JSON.stringify(triggerExperiment.ruleConditions)),
        conditions: triggerExperiment.ruleConditions.conditions?.map((condition)=>({
                type: "condition",
                ...condition
            })) || []
    } : null;
    const ruleConditions = transformedRuleConditions ? RuleEditorSchema.parse(transformedRuleConditions) : null;
    return {
        ...triggerExperiment,
        interval,
        ruleConditions
    };
};
